import LoginProcess from "../../components/login/LoginProcess";
import style from "./login.module.css";
import Modal from "../../components/modal/Modal";
interface LoginModalProps {
  isModal: boolean;
  onClose: () => void;
}
const LoginModal = ({ isModal, onClose }: LoginModalProps) => {
  return (
    <Modal
      className={style["login-process"]}
      isModal={isModal}
      onClose={onClose}
    >
      <div className={style.inner}>
        <LoginProcess />
      </div>
    </Modal>
  );
};

export default LoginModal;
